<template>
  <div>
    <navbar></navbar>
    <main-box></main-box>
    <footerContent></footerContent>
  </div>
</template>

<script>
import navbar from '@/components/navbar'
import mainBox from './mainBox'
import footerContent from '@/components/footerContent'

export default {
  name: 'EventDetail',
  components: {
    navbar,
    mainBox,
    footerContent
  }
}
</script>

<style lang="scss" scoped>
::v-deep .footer .social-bar{
  display: none;
}

::v-deep .cw-main_navbar {
  margin-bottom: 0;
}
</style>
